import {
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@material-ui/core';
import {AssignmentInd} from '@material-ui/icons';
import OrgPopover from 'components/OrgPopover';
import {UserContext} from 'context/UserContext';
import {useFlags} from 'hooks';
import {useState} from 'react';
import {useContext} from 'react';
import {NavItemList} from './LoggedInNavBar';

const PortalNavItems = () => {
    const {
        user: {permissions},
        organization_info: orgs,
    } = useContext(UserContext);
    const managingOrgs = orgs?.managing_orgs;
    const {employer_portal_active} = useFlags();
    const [anchorEl, setAnchorEl] = useState(null);
    const popoverOpen = Boolean(anchorEl);
    const id = popoverOpen ? 'org-popover' : undefined;

    const handleClick = e => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    if (employer_portal_active) {
        if (permissions?.canViewOrgs || orgs?.managing_orgs?.length > 1) {
            return [
                <List key='portal-list'>
                    <ListItem button onClick={handleClick}>
                        <ListItemIcon>
                            <AssignmentInd />
                        </ListItemIcon>
                        <ListItemText primary='Employer Portal' />
                    </ListItem>
                </List>,
                <OrgPopover
                    key='org-popover'
                    open={popoverOpen}
                    id={id}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    handleClose={handleClose}
                    myOrgs={permissions?.canViewOrgs ? undefined : managingOrgs}
                />,
                <Divider key='portal-divider' />,
            ];
        } else if (orgs?.managing_orgs?.length) {
            return (
                <NavItemList
                    itemList={[
                        {
                            name: 'Employer Portal',
                            icon: <AssignmentInd />,
                            to: `/portal/${orgs?.managing_orgs?.[0]?.id}`,
                        },
                    ]}
                    key='employer-portal'
                    name='employer-portal'
                />
            );
        }
    }
    return null;
};

export default PortalNavItems;
